import { ORCHID_PRO_TYPE_OPTIONS } from "./constants";

export default function getOrchidProTypeLabel(orchidProType) {
  return ORCHID_PRO_TYPE_OPTIONS.find(
    (option) => option.value === orchidProType,
  )?.label;
}
